const initialValues = {
  patient_uuid: "",
  start_hour: "",
  end_hour: "",
};

export default initialValues;
